<template>
  <div class="box">


<p>Message is: {{ fee.recommended_message }}</p>


    <div class="media-content">
      <div class="content">
        <div class="columns">
          <div class="column">

            <b-field label="Ingrese su monto">
              <b-input v-model="quantity" type="number" placeholder="Ingrese una cantidad" rounded></b-input>
            </b-field>
          </div>
          <div class="column">



            <b-field label="Cantidad de coutas">
                <b-select  placeholder="Select a character" rounded>
                    <option v-for="item in fee" v-model="feed_select" :value="item.recommended_message" >{{ item.recommended_message}}</option>

                </b-select>
            </b-field>

        </div>
        <div class="column">

          <button class="button is-primary is-medium"
          @click="open(quantity)">
          Consultar
        </button>
        </div>
      </div>

      <div class="columns">
        <div class="column">

          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Total a Pagar</p>
                <p class="title">{{ total }}</p>
              </div>
            </div>

          </nav>
        </div>



      </div>





    </div>
    <nav class="level is-mobile">
      <div class="level-left">
        <a class="level-item">
          <span class="icon is-small"><i class="fas fa-reply"></i></span>
        </a>
        <a class="level-item">
          <span class="icon is-small"><i class="fas fa-retweet"></i></span>
        </a>
        <a class="level-item">
          <span class="icon is-small"><i class="fas fa-heart"></i></span>
        </a>
      </div>
    </nav>
  </div>

</div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      quantity: '',
      total: '',
      fee: '',
      feed_select: ''
    }
  },
  methods: {
    open(quantity) {

      let percentage = quantity * 40 / 100

      const totalCount = parseInt(quantity) - parseInt(percentage)

      this.total = totalCount


      const loadingComponent = this.$loading.open()
      setTimeout(() => loadingComponent.close(), 3 * 1000)
      axios.get(`https://api.mercadopago.com/v1/payment_methods/installments?access_token=APP_USR-2927642208869156-030701-c935a22cbd1e4f7dedd65d4314ac63f2__E_I__-306085896&payment_method_id=visa&amount=${totalCount}`)
      .then(response => {
        console.log(response.data)
        // JSON responses are automatically parsed.
        this.fee = response.data['0'].payer_costs
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/credits/Fees.vue